import { render, staticRenderFns } from "./Horse.vue?vue&type=template&id=518991d4&scoped=true"
import script from "./Horse.vue?vue&type=script&lang=js"
export * from "./Horse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518991d4",
  null
  
)

export default component.exports